// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class CurrentBudgetDto extends APIModel {
    /**
    * Currently available budget
    */
    currentAvailable: number;
    /**
    * Already withdrawn money
    */
    currentRealized: number;

    constructor(options?: APIModelOptions) {
        super(CurrentBudgetDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "currentAvailable", type: "number" },
            { name: "currentRealized", type: "number" }
        ];
    }
}




